/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { createSelector, createSlice, isRejected } from '@reduxjs/toolkit';
import { AlertVariantType } from '../../enums/AlertTypes';
import { createAlert } from './alerts.helper';

/* Initial State */
const initialState = {
  data: [],
};

/* Matchers */
const isThunkRejectedMatcher = (action) => {
  return isRejected(action) && action?.payload?.showAlert !== false && action?.payload?.code !== 'ERR_CANCELED' && action?.payload?.error?.code !== 'ECONNABORTED';
};

/* Slice */
export const alertsSlice = createSlice({
  name: 'alerts',
  initialState,
  reducers: {
    showAlertError(state, action) {
      addAlertReducer(state, action, AlertVariantType.ERROR);
    },
    showAlertSuccess(state, action) {
      addAlertReducer(state, action, AlertVariantType.SUCCESS);
    },
    showAlertWarning(state, action) {
      addAlertReducer(state, action, AlertVariantType.WARNING);
    },
    showAlertInfo(state, action) {
      addAlertReducer(state, action, AlertVariantType.INFO);
    },
    removeAlert(state, action) {
      state.data = state.data.filter(({ id }) => id !== action.payload);
    },
  },
  extraReducers(builder) {
    builder.addMatcher(isThunkRejectedMatcher, (state, action) => {
      addAlertReducer(state, action, AlertVariantType.ERROR);
    });
  },
});

/* Reducer */
const addAlertReducer = (state, action, alertType) => {
  const alert = createAlert(action, alertType);
  state.data = [...state.data, alert];
};
/* Selectors */
const selectAlerts = state => state[alertsSlice.name];
export const selectAlertsData = createSelector(selectAlerts, ({ data }) => data);
export const { showAlertError, showAlertSuccess, showAlertWarning, showAlertInfo, removeAlert } = alertsSlice.actions;
